import React from 'react';
import { Alert, Box, Button, Collapse } from '@mui/material';
import RefreshIcon from '@mui/icons-material/Refresh';
import { useNetworkStatus } from '../hooks/useNetworkStatus';
import { useLanguage } from '../i18n/LocalizationContext';

const NetworkStatusBanner: React.FC = () => {
  const { isOnline, message, refresh } = useNetworkStatus();
  const { t } = useLanguage();

  return (
<Collapse in={!isOnline} unmountOnExit>
  <Box
    sx={{
      position: 'sticky',
      top: 16,
      zIndex: (theme) => theme.zIndex.snackbar,
      display: 'flex',
      justifyContent: 'center',
      px: 2,
    }}
  >
    <Alert
      severity="warning"
      action={
        <Button
          color="inherit"
          size="small"
          startIcon={<RefreshIcon fontSize="small" />}
          onClick={() => {
            void refresh();
          }}
          sx={{ whiteSpace: 'nowrap' }}
        >
          {t('common.retry')}
        </Button>
      }
      sx={{
        alignItems: 'center',
        borderRadius: 2,
        width: 'fit-content',
        maxWidth: 600,
      }}
    >
      {t(message)}
    </Alert>
  </Box>
</Collapse>
  );
};

export default NetworkStatusBanner;
